<template>
  <div class="pc-login-container">
    <!-- 左侧品牌区域 -->
    <div class="brand-section">
      <div class="brand-logo">
        <img src="/img/study.png" alt="品牌logo" />
      </div>
      <p class="brand-slogan">让学习更简单，让转学更轻松</p>
      <div class="brand-image">
        <img src="/img/01.jpg" alt="品牌形象" />
      </div>
    </div>

    <!-- 右侧注册表单区域 -->
    <div class="login-form-section">
      <div class="form-card">
        <h2 class="form-title">注册账号</h2>
        <cube-form ref="cubeForm" :model="model" :schema="schema" @validate="handleValidate"></cube-form>
        <form name="forms" class="login-cont">
          <button type="button" class="login-btn" @click="handleRegister">
            <span class="btn-text">注 册</span>
            <i class="btn-icon cubeic-right"></i>
          </button>
        </form>
        <div class="form-footer">
          <p>© 2025 ShangAn. All rights reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisteredPC',
  props: {
    model: {
      type: Object,
      required: true
    },
    schema: {
      type: Object,
      required: true
    }
  },
  methods: {
    async handleRegister(e) {
      e.preventDefault();
      this.$emit('register');
    },
    handleValidate(ret) {
      return new Promise(resolve => {
        const { username, phone, password, checkPassword } = ret.validity;
        let isFormValid = username.valid && phone.valid && password.valid && checkPassword.valid ? true : false;
        resolve(isFormValid);
      });
    },
    validate() {
      return this.$refs.cubeForm.validate();
    }
  }
};
</script>

<style>
@import "../assets/stytels/login-pc.css";
</style>
